var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtalSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.99984H16.2665C15.9023 9.99906 15.5479 10.1176 15.2574 10.3373C14.967 10.557 14.7565 10.8658 14.6582 11.2165L12.6998 18.1832C12.6872 18.2264 12.6609 18.2645 12.6248 18.2915C12.5888 18.3186 12.5449 18.3332 12.4998 18.3332C12.4548 18.3332 12.4109 18.3186 12.3748 18.2915C12.3388 18.2645 12.3125 18.2264 12.2998 18.1832L7.69984 1.8165C7.68722 1.77323 7.6609 1.73522 7.62484 1.70817C7.58878 1.68112 7.54491 1.6665 7.49984 1.6665C7.45476 1.6665 7.4109 1.68112 7.37484 1.70817C7.33878 1.73522 7.31246 1.77323 7.29984 1.8165L5.3415 8.78317C5.24356 9.13247 5.03432 9.44027 4.74556 9.65985C4.45679 9.87943 4.10427 9.9988 3.7415 9.99984H1.6665",
    stroke: "#1C64F2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtalSign);
export default __webpack_public_path__ + "static/media/virtalSign.8b5dece20f384908b0f7b26cebfbc0f5.svg";
export { ForwardRef as ReactComponent };